import { SxStyles } from '../../types';

export const PractitionerMediaPreviewPlayerStyle: SxStyles = {
  PractitionerMediaPreviewPlayerPsylarisLibrary: {
    position: 'absolute',
    zIndex: 2,
    width: '100%',
    height: '80%',
    '& .player-container': {
      position: 'absolute',
      zIndex: 2,
      height: 'auto',
      minHeight: '360px',
      width: '100%',
      right: 5,
      top: 0,
      padding: '1em',
      maxWidth: '50%',
      display: 'flex',
      justifyContent: 'flex-end',
      '& .player-overlay': {
        position: 'absolute',
        top: 10,
        left: 0,
        bottom: 0,
        right: 10,
      },
      '& .react-player': {
        minHeight: '360px',
        height: '100%',
      },
    },
    ' .player-container-image': {
      position: 'absolute',
      zIndex: 2,
      width: '100%',
      right: 5,
      top: 0,
      padding: '1em',
      display: 'flex',
      justifyContent: 'flex-end',
      '& .player-overlay': {
        position: 'absolute',
        top: 10,
        left: 0,
        bottom: 0,
        right: 10,
      },
      '& .player-overlay-image': {
        position: 'relative',
        width: '50%',
        display: 'flex',
        height: '100%',
        '&::before': {
          content: '""',
          display: 'block',
          paddingTop: '56.25%',
        },
        '& img': {
          position: 'absolute',
          alignSelf: 'center',
          top: '0',
          left: '0',
          width: '100%',
          height: '100%',
          objectFit: 'contain',
        },
      },
    },
  },
};
